export const TOASTER_Z_INDEX = 10100
export const MODAL_Z_INDEX = 10000
export const PANEL_Z_INDEX = 9999
export const HEADER_Z_INDEX = 9000
